import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { actionTypes } from '../reducer';
import FilterTypes from '../../../constants/FilterTypes.ts';
import { hasGlobalTerritoriesApplied } from '@helpers/territories';

export default ({
  filters,
  dispatch,
  optionalFilters,
  frequenciesForSelect,
  inspectionTypesForSelect,
  subcontractorsForSelect,
  assetsForSelect,
  buildingId,
  inspectionSeriesId,
  accountId
}) => {
  const filtersList = [
    {
      field: 'scheduledDate',
      locale: 'scheduled_date',
      type: 'dateRangePicker',
      active: filters.active.scheduledDate,
      values: filters.values.scheduledDate,
      onChange: onChangeDateFilter('scheduledDate', dispatch),
      onToggle: onToggleFilter('scheduledDate', dispatch)
    },
    {
      field: 'frequency',
      locale: 'frequency',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.frequency,
      optionsForSelect: frequenciesForSelect.map((opt) => ({
        title: opt.label,
        value: opt.value
      })),
      value: filters.values.frequency,
      onChange: onChangeReactFilter('frequency', dispatch),
      onToggle: onToggleFilter('frequency', dispatch)
    },
    {
      field: 'building',
      locale: 'building',
      type: buildingId || inspectionSeriesId ? 'hidden' : FilterTypes.GenericMultiSelect,
      active: filters.active.building,
      value: filters.values.building,
      onChange: handleMultiSelectFilterChange('building', dispatch),
      onToggle: onToggleFilter('building', dispatch)
    },
    {
      field: 'status',
      locale: 'status',
      disableSorting: true,
      type: FilterTypes.GenericMultiSelect,
      backendField: 'status',
      active: filters.active.status,
      value: filters.values.status,
      onChange: handleMultiSelectFilterChange('status', dispatch),
      onToggle: onToggleFilter('status', dispatch),
      tagTemplate: statusTagTemplate,
      itemTemplate: statusItemTemplate,
      withIcons: true
    },
    {
      field: 'technician',
      locale: 'technician',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.technician,
      value: filters.values.technician,
      disableSorting: true,
      onChange: handleMultiSelectFilterChange('technician', dispatch),
      onToggle: onToggleFilter('technician', dispatch),
      withUnassigned: true,
      allowLetterAvatar: true
    },
    {
      field: 'technicianTeam',
      locale: 'technician_team',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.technicianTeam,
      value: filters.values.technicianTeam,
      onChange: handleMultiSelectFilterChange('technicianTeam', dispatch),
      onToggle: onToggleFilter('technicianTeam', dispatch)
    },
    {
      field: 'asset',
      locale: 'asset',
      type: FilterTypes.TreeMultiSelect,
      active: filters.active.asset,
      value: filters.values.asset,
      optionsForSelect: assetsForSelect,
      onChange: handleMultiSelectFilterChange('asset', dispatch),
      onToggle: onToggleFilter('asset', dispatch)
    },
    {
      field: 'buildingStatus',
      locale: 'building_status',
      type: buildingId || inspectionSeriesId ? 'hidden' : 'booleanSelect',
      active: buildingId || inspectionSeriesId ? false : filters.active.buildingStatus,
      value: filters.values.buildingStatus,
      onChange: onChangeReactFilter('buildingStatus', dispatch),
      onToggle: onToggleFilter('buildingStatus', dispatch)
    },
    {
      field: 'account',
      locale: 'account',
      type: accountId ? 'hidden' : FilterTypes.GenericMultiSelect,
      active: filters.active.account,
      value: filters.values.account,
      onChange: handleMultiSelectFilterChange('account', dispatch),
      onToggle: onToggleFilter('account', dispatch)
    },
    {
      field: 'noAccess',
      locale: 'no_access',
      type: 'booleanSelect',
      active: filters.active.noAccess,
      value: filters.values.noAccess,
      onChange: onChangeReactFilter('noAccess', dispatch),
      onToggle: onToggleFilter('noAccess', dispatch)
    },
    {
      field: 'zipCode',
      locale: 'zip_code',
      type: 'textBox',
      active: filters.active.zipCode,
      value: filters.values.zipCode,
      onChange: onChangeReactFilter('zipCode', dispatch),
      onToggle: onToggleFilter('zipCode', dispatch)
    },
    {
      field: 'referenceNumber',
      locale: 'reference_number',
      type: 'textBox',
      active: filters.active.referenceNumber,
      value: filters.values.referenceNumber,
      onChange: onChangeReactFilter('referenceNumber', dispatch),
      onToggle: onToggleFilter('referenceNumber', dispatch)
    },
    {
      field: 'workOrder',
      locale: 'work_order',
      type: 'textBox',
      active: filters.active.workOrder,
      value: filters.values.workOrder,
      onChange: onChangeReactFilter('workOrder', dispatch),
      onToggle: onToggleFilter('workOrder', dispatch)
    },
    {
      field: 'tags',
      backendField: 'tags',
      locale: 'inspection_tags',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.tags,
      value: filters.values.tags,
      onChange: handleMultiSelectFilterChange('tags', dispatch),
      onToggle: onToggleFilter('tags', dispatch)
    },
    {
      field: 'buildingTags',
      backendField: 'tags',
      locale: 'building_tags',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.buildingTags,
      value: filters.values.buildingTags,
      onChange: handleMultiSelectFilterChange('buildingTags', dispatch),
      onToggle: onToggleFilter('buildingTags', dispatch)
    },
    {
      field: 'accountTags',
      backendField: 'tags',
      locale: 'account_tags',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.accountTags,
      value: filters.values.accountTags,
      onChange: handleMultiSelectFilterChange('accountTags', dispatch),
      onToggle: onToggleFilter('accountTags', dispatch)
    },
    {
      field: 'workOrderTags',
      backendField: 'tags',
      locale: 'work_order_tags',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.workOrderTags,
      value: filters.values.workOrderTags,
      onChange: handleMultiSelectFilterChange('workOrderTags', dispatch),
      onToggle: onToggleFilter('workOrderTags', dispatch)
    },
    {
      field: 'inspectionDate',
      locale: 'inspection_date',
      type: 'dateRangePicker',
      active: filters.active.inspectionDate,
      values: filters.values.inspectionDate,
      onChange: onChangeDateFilter('inspectionDate', dispatch),
      onToggle: onToggleFilter('inspectionDate', dispatch)
    },
    {
      field: 'dueDate',
      locale: 'due_date',
      type: 'dateRangePicker',
      active: filters.active.dueDate,
      values: filters.values.dueDate,
      onChange: onChangeDateFilter('dueDate', dispatch),
      onToggle: onToggleFilter('dueDate', dispatch)
    },
    {
      field: 'visitDate',
      locale: 'visit_date',
      type: 'dateRangePicker',
      active: filters.active.visitDate,
      values: filters.values.visitDate,
      onChange: onChangeDateFilter('visitDate', dispatch),
      onToggle: onToggleFilter('visitDate', dispatch)
    },
    {
      field: 'inspectionId',
      locale: 'inspection_id',
      type: 'textBox',
      active: filters.active.inspectionId,
      value: filters.values.inspectionId,
      onChange: onChangeReactFilter('inspectionId', dispatch),
      onToggle: onToggleFilter('inspectionId', dispatch)
    }
  ];

  if (!hasGlobalTerritoriesApplied()) {
    filtersList.push({
      field: 'territory',
      locale: 'territory',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.territory,
      value: filters.values.territory,
      withUnassigned: true,
      onChange: handleMultiSelectFilterChange('territory', dispatch),
      onToggle: onToggleFilter('territory', dispatch)
    });
  }

  filtersList.push({
    field: 'additionalTerritory',
    backendField: 'additional_territory',
    locale: 'additional_territory',
    type: FilterTypes.GenericMultiSelect,
    active: filters.active.additionalTerritory,
    value: filters.values.additionalTerritory,
    onChange: handleMultiSelectFilterChange('additionalTerritory', dispatch),
    onToggle: onToggleFilter('additionalTerritory', dispatch)
  });

  if (optionalFilters.subcontractor) {
    filtersList.push({
      field: 'subcontractor',
      locale: 'subcontractor',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.subcontractor,
      optionsForSelect: subcontractorsForSelect
        .map((opt) => ({ title: opt.label, value: opt.value }))
        .filter(({ value }) => value !== 'all'),
      value: Array.isArray(filters.values.subcontractor || [])
        ? filters.values.subcontractor
        : [filters.values.subcontractor],
      onChange: onChangeReactFilter('subcontractor', dispatch),
      onToggle: onToggleFilter('subcontractor', dispatch)
    });
  }

  if (optionalFilters.tce) {
    filtersList.push({
      field: 'tce',
      locale: 'tce',
      type: 'checkbox',
      active: filters.active.tce,
      value: filters.values.tce,
      onChange: onChangeReactFilter('tce', dispatch),
      onToggle: onToggleFilter('tce', dispatch)
    });
  }

  if (optionalFilters.tceErrors) {
    filtersList.push({
      field: 'tceErrors',
      locale: 'tce_errors',
      type: 'checkbox',
      active: filters.active.tceErrors,
      value: filters.values.tceErrors,
      onChange: onChangeReactFilter('tceErrors', dispatch),
      onToggle: onToggleFilter('tceErrors', dispatch)
    });
  }

  if (optionalFilters.irol) {
    filtersList.push({
      field: 'irol',
      locale: 'irol',
      type: 'checkbox',
      active: filters.active.irol,
      value: filters.values.irol,
      onChange: onChangeReactFilter('irol', dispatch),
      onToggle: onToggleFilter('irol', dispatch)
    });
  }

  if (optionalFilters.irolErrors) {
    filtersList.push({
      field: 'irolErrors',
      locale: 'irol_errors',
      type: 'checkbox',
      active: filters.active.irolErrors,
      value: filters.values.irolErrors,
      onChange: onChangeReactFilter('irolErrors', dispatch),
      onToggle: onToggleFilter('irolErrors', dispatch)
    });
  }

  if (optionalFilters.livsafe) {
    filtersList.push({
      field: 'livsafe',
      locale: 'livsafe',
      type: 'checkbox',
      active: filters.active.livsafe,
      value: filters.values.livsafe,
      onChange: onChangeReactFilter('livsafe', dispatch),
      onToggle: onToggleFilter('livsafe', dispatch)
    });
  }

  if (optionalFilters.livsafeErrors) {
    filtersList.push({
      field: 'livsafeErrors',
      locale: 'livsafe_errors',
      type: 'checkbox',
      active: filters.active.livsafeErrors,
      value: filters.values.livsafeErrors,
      onChange: onChangeReactFilter('livsafeErrors', dispatch),
      onToggle: onToggleFilter('livsafeErrors', dispatch)
    });
  }

  if (optionalFilters.inspectionType) {
    filtersList.push({
      field: 'inspectionType',
      locale: 'inspection_type',
      type: FilterTypes.GenericMultiSelect,
      active: filters.active.inspectionType,
      optionsForSelect: inspectionTypesForSelect.map((opt) => ({ title: opt.label, value: opt.value })),
      value: filters.values.inspectionType,
      onChange: handleMultiSelectFilterChange('inspectionType', dispatch),
      onToggle: onToggleFilter('inspectionType', dispatch)
    });
  }

  return filtersList;
};

const onToggleFilter = (fieldName, dispatch) => {
  return () => {
    dispatch({ type: actionTypes.FILTER_TOGGLED, field: fieldName });
  };
};

const onChangeDateFilter = (fieldName, dispatch) => {
  return (dateFieldName, value) => {
    dispatch({
      type: actionTypes.DATE_RANGE_FILTER_CHANGED,
      field: fieldName,
      dateField: dateFieldName,
      value
    });
  };
};

const handleMultiSelectFilterChange = (fieldName, dispatch) => {
  return (value) => {
    dispatch({ type: actionTypes.FILTER_CHANGED, value, field: fieldName });
  };
};

const onChangeReactFilter = (fieldName, dispatch) => {
  return (value) => {
    dispatch({ type: actionTypes.FILTER_CHANGED, value, field: fieldName });
  };
};

const statusTagTemplate = ReactDOMServer.renderToString(
  <span className="qmb-avatar--24--status-icon">
    <i className="fa-lg #: icon #" style={{ color: '#: color #' }} />
  </span>
);

const statusItemTemplate = ReactDOMServer.renderToString(
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span
      className="qmb-avatar--24--status-icon"
      style={{ display: 'flex', borderRadius: '50%', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-lg #: icon #" style={{ color: '#: color #' }} />
    </span>
    <div style={{ marginLeft: '0.8rem' }}>#: label #</div>
  </div>
);
